export const CAMERA_MOVEMENT_CREDIT_CHECK = 'cameraMovement';
export const CAMERA_ZOOM_CREDIT_CHECK = 'cameraZoom';
export const CAPTURE_CLIP_CREDIT_CHECK = 'captureClip';
export const CAPTURE_PHOTO_CREDIT_CHECK = 'capturePhoto';
